<template>
  <div
    class="input-wrapper"
    :class="{
      'start-left': startLeft
    }"
  >
    <div class="input-data">
      <input
        required
        autocomplete="off"
        :type="inputType"
        :value="modelValue"
        @input="updateValue"
        :style="{ paddingRight: pr + 'px' }"
      />
      <label :class="[animateType, starLabel ? 'star' : '']">
        {{ label }}</label
      >
      <img
        class="input__img"
        :src="socialIcon"
        v-show="flip"
        @load="flip = !flip"
      />
      <img class="input__img" src="@img/preload-logo.svg" v-if="!flip" />
      <div class="underline" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialInput',
  props: {
    modelValue: {
      type: [String, Number]
    },
    label: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    animateType: {
      type: String,
      default: 'remove'
    },
    startLeft: {
      type: Boolean,
      default: false
    },
    charCountToRemove: {
      type: Number,
      default: 5
    },
    starLabel: {
      type: Boolean,
      default: false
    },
    pr: {
      type: Number
    },
    // #TODO add a default img
    socialIcon: {
      type: String
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      flip: false
    }
  },
  methods: {
    updateValue($event) {
      this.$emit('update:modelValue', $event.target.value)
    }
  },
  watch: {
    modelValue(newValue) {
      const el = this.$el.querySelector('label')
      if (newValue.length > this.charCountToRemove) {
        el.classList.add('remove')
      } else {
        el.classList.remove('remove')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  margin: 12px 0;
  .input-data {
    width: 100%;
    height: 40px;
    position: relative;

    label {
      position: absolute;
      font-size: 15px;
      top: 10px;
      right: 48px;
      color: #b4b4b4;
      pointer-events: none;
      transition: all 0.5s ease;
      &.star {
        bottom: -1px;
        &::before {
          position: relative;
          content: '*';
          color: #c69d4e;
          font-size: 20px;
          top: 6px;
          margin-left: 3px;
        }
      }
    }

    input {
      font-size: 17px;
      height: 100%;
      width: 100%;
      color: #000;
      background-color: transparent;
      border: none;
      outline: none;
      border-bottom: 1px solid black;
      text-align: right;
      padding: 2px 4px 0px;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      &[type='number'] {
        -moz-appearance: textfield;
      }

      &:focus {
        ~ div.underline::before {
          transform: translateX(0);
        }
      }
      &:focus,
      &:valid {
        ~ label.decrease {
          transform: translateY(-25px);
          font-size: 15px;
        }
        ~ label.remove {
          opacity: 0;
        }
        ~ label.static {
        }
      }
    }

    .underline {
      overflow: hidden;
      position: absolute;
      width: 100%;
      bottom: 0;
      height: 2px;
      z-index: 2;

      &::before {
        content: '';
        position: absolute;
        background-color: #c69d4e;
        width: 100%;
        right: 0;
        height: 100%;
        transform: translateX(100%);
        transition: transform 0.5s ease;
      }
    }

    img {
      position: absolute;
      width: 40px;
      height: 40px;
      right: 0;
      top: -5px;
      border-radius: 8px;
      .svg-color {
        fill: #666667;
      }
    }
  }
  &.light .input-data {
    $light-color: #777;
    input {
      border-bottom: 1px solid $light-color;
      color: white;
    }
  }

  &.start-left .input-data input {
    direction: ltr;
    text-align: left;
  }
}
</style>
